import type { VueI18n } from 'vue-i18n'
import { LOCALE_REDIRECT_KEY } from '@ldshop/build/i18n'

export default defineNuxtPlugin((nuxt) => {
  const i18n = nuxt.vueApp.config.globalProperties.$i18n as VueI18n
  const { userLocale } = storeToRefs(userStore())
  const localeRedirectCookie = useCookie(LOCALE_REDIRECT_KEY)
  userLocale.value = i18n.locale

  watch(
    () => i18n.locale,
    () => {
      userLocale.value = i18n.locale
      localeRedirectCookie.value = userLocale.value
    },
    {
      flush: 'sync',
    },
  )
})
